export default __webpack_public_path__ + "static/media/tab5.cc2401fa.svg";